import React, { Component } from 'react'
import compose from 'lodash/fp/compose'

import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import List from 'client/bookmate/blocks/list'
import Shelf from 'client/bookmate/blocks/shelf'

import { ShelfProps } from 'client/shared/types/shelf'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  shelves: ShelfProps[]
  header?: string
  allLink?: string
  currentUserLogin: string
  query?: QueryParams
} & DecoratorProps

class MoreShelves extends Component<Props> {
  render(): JSX.Element {
    const {
      header,
      allLink,
      shelves,
      currentUserLogin,
      isMobileSize,
      isTabletSize,
      query,
    } = this.props

    const listType = isMobileSize() || isTabletSize() ? 'slider' : 'default'

    return (
      <List type={listType} header={header} allLink={allLink} localizedHeader>
        {shelves.map((shelf, i) => {
          return (
            <Shelf
              query={query}
              key={i}
              kind="grid"
              shelf={shelf}
              showPlus={shelf.creator.login !== currentUserLogin}
            />
          )
        })}
      </List>
    )
  }
}

const wrappers = compose(uiBox)

export default wrappers(MoreShelves)
